import React, { useEffect, useState, useRef } from "react";
import {
  DeleteAPICall,
  postAPICall,
  putAPICall,
  setToastRef,
  showErrorToast,
  showSuccessToast,
  // showToast,
} from "../Api/Api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import "./AdminStyle.css";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { IoAddOutline } from "react-icons/io5";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import GlobalPopup from "../GlobalComponents/GlobalPopup";
import { InputNumber } from "primereact/inputnumber";
export default function UserToAccountGroup(props) {
  const [accountGroupType, setAccountGroupType] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedChennal, setSelectedChennal] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editedAccountGroup, setEditedAccountGroup] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const [newChannelData, setNewChannelData] = useState({});
  const [days, setDays] = useState(10);
  const [accountGroupNameValid, setAccountGroupNameValid] = useState(true);
  const [accountGroupCodeValid, setAccountGroupCodeValid] = useState(true);

  const toast = useRef(null);

  useEffect(() => {
    setToastRef(toast.current);
    fetchAccountGroupType();
  }, [props]);

  const fetchAccountGroupType = async () => {
    try {
      let NewUserID = props.newUserId;
      const requestBody = {
        UserId: NewUserID,
      };
      const response = await postAPICall(
        "api/AccountGroup/GetAccountGroup",
        requestBody
      );
      setAccountGroupType(response?.data);
      const preSelectedRows = response?.data?.filter(
        (row) => row.UserId === NewUserID
      );
      setSelectedRows(preSelectedRows);
    } catch (error) {
      showErrorToast("Error fetching account group type:");
    }
  };

  const onRowSelected = (event) => {
    debugger
    if (!isNaN(event.value)) {
      return;
    }
    // props?.setToMailData(null);
    const x = event?.value?.length ==0 ?props?.setToMailData(null):""; 
    setSelectedRows(event?.data);
    if (event?.value != null) {
      let x = props?.onClickFromMail
        ? props?.onClickFromMail(event?.value || event?.value[0])
        : "";
    }
    if (selectedItem?.AccountGroupName === event.value?.AccountGroupName) {
      setSelectedItem(null); // Deselect if clicked again
    } else {
      setSelectedItem(event.value); // Select the new row
    }
  };

  const Chkboxunselect = async (e) => {
    if (e?.data?.UserAccountMapId != null) {
      const UserAccountMapId = e.data.UserAccountMapId;
      const requestBody = {
        UserAccountMapId: UserAccountMapId,
      };
      try {
        const response = await DeleteAPICall(
          "api/AccountGroup/DeleteAccountGroup",
          requestBody
        );
        fetchAccountGroupType();
        showSuccessToast("Deleted Successfully ...");
      } catch (error) {
        console.error(
          `Error making API call for UserAccountMapId: ${UserAccountMapId}`,
          error
        );
      }
    }
  };
  const Chkboxselect = async (e) => {
    if (props.newUserId) {
      const requestBody = {
        UserId: props.newUserId,
        AccountgroupId: e.data.AccountgroupId,
      };
      try {
        if (props.newUserId) {
          const response = await postAPICall(
            "api/AccountGroup/PostAccountGroup",
            requestBody
          );
          fetchAccountGroupType();
          showSuccessToast("Channel Added Successfully ...");
        } else {
          showErrorToast(
            "Please select your username and then click 'Check'..."
          );
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const HandleAllrowselect = async (e) => {
    try {
      const nullUserIdRows = e.data.filter((row) => row.UserId === null);
      const promises = nullUserIdRows.map((row) => {
        const requestBody = {
          UserId: props.newUserId,
          AccountgroupId: row.AccountgroupId,
        };
        return postAPICall("api/AccountGroup/PostAccountGroup", requestBody);
      });
      await Promise.all(promises);
      fetchAccountGroupType();
      showSuccessToast( "All Channels Added Successfully ...");
    } catch (error) {
      showErrorToast("Error selecting all rows:");
    }
  };

  const HandleAllRowUnSelect = async () => {
    try {
      const accountGroupIds = accountGroupType.map(
        (item) => item.UserAccountMapId
      );
      for (const UserAccountMapId of accountGroupIds) {
        const requestBody = {
          UserAccountMapId: UserAccountMapId,
        };
        try {
          const response = await DeleteAPICall(
            "api/AccountGroup/DeleteAccountGroup",
            requestBody
          );
        } catch (error) {
          console.error(
            `Error deleting UserAccountMapId: ${UserAccountMapId}`,
            error
          );
        }
        fetchAccountGroupType();
      }
      showSuccessToast("All Channels Deleted Successfully ...");
    } catch (error) {
       showErrorToast("Error deleting account groups:");
    }
  };

  const filteredAccountGroupType = accountGroupType?.filter((channel) =>
    channel.AccountGroupName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleEdit = (rowData) => {
    setSelectedChennal(rowData);
    setEditDialogVisible(true);
    setEditedAccountGroup({ ...rowData });
  };

  const handleDelete = () => {
    setDeleteConfirmation(true); // Set deleteConfirmation to true if it's false
    // Set deleteConfirmation to true if it's false
  };
  const actionTemplate = (rowData) => {
    const handleActionClick = (e) => {
      e.stopPropagation();
    };
    return (
      <div onClick={handleActionClick}>
        <Button
          id="UserTOAccountEditIcon"
          icon={<MdModeEdit />}
          title="Edit"
          className="p-button-rounded p-button-primary p-mr-2"
          onClick={() => handleEdit(rowData)}
        />
        <Button
          id="UserTOAccountDeleteIcon"
          icon={<MdDelete />}
          title="Delete"
          className="p-button-rounded p-button-primary"
          onClick={() => {
            setSelectedChennal(rowData);
            handleDelete();
          }}
        />
      </div>
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedAccountGroup((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleNewInputChange = (e, field) => {
    setNewChannelData((prevData) => ({
      ...prevData,
      [field]: e.target.value,
    }));
  };

  const handleSubmitEdit = async () => {
    try {
      if (
        !editedAccountGroup.AccountGroupName ||
        !editedAccountGroup.AccountGroupCode
      ) {
        showErrorToast( "Please fill in all fields.");
        setAccountGroupNameValid(!!editedAccountGroup.AccountGroupName);
        setAccountGroupCodeValid(!!editedAccountGroup.AccountGroupCode);
        return;
      }

      const requestBody = {
        AccountGroupCode: editedAccountGroup.AccountGroupCode,
        AccountGroupName: editedAccountGroup.AccountGroupName,
        AccountgroupId: editedAccountGroup.AccountgroupId,
        days: days ? days : editedAccountGroup?.Days,
      };
      const response = await putAPICall(
        "api/AccountGroup/PutAccountGroupHeader",
        requestBody
      );
      fetchAccountGroupType();
      setEditDialogVisible(false);
      showSuccessToast("Updated Successfully...");
    } catch (error) {
      console.error(error);
    }
  };

  const handleNewSubmit = async () => {
    try {
      if (
        !newChannelData.AccountGroupName ||
        !newChannelData.AccountGroupCode
      ) {
        showErrorToast("Please fill in all fields...");
        setAccountGroupNameValid(!!newChannelData.AccountGroupName);
        setAccountGroupCodeValid(!!newChannelData.AccountGroupCode);
        return;
      }
      const requestBody = {
        AccountGroupName: newChannelData.AccountGroupName,
        AccountGroupCode: newChannelData.AccountGroupCode,
      };
      const response = await postAPICall(
        "api/AccountGroup/PostAccountGroupHeader",
        requestBody
      );
      fetchAccountGroupType();
      showSuccessToast( "Added Successfully...");
      setNewChannelData([]);
      setShowDialog(false);
    } catch (error) {
      console.error(error);
    }
  };

  const AddNewChannelFooter = (
    <div>
      <Button
        id="BtnSave"
        label="Save"
        icon="pi pi-check"
        onClick={handleNewSubmit}
        autoFocus
      />
      <Button
        id="BtnCancel"
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setShowDialog(false)}
        className="p-button-text"
      />
    </div>
  );
  const AddChannelContent = (
    <>
      <div className="p-fluid" style={{ padding: "10px" }}>
        <div className="p-field">
          <label htmlFor="AccountGroupName">AccountGroupName</label>
          <InputText
            id="AccountGroupName"
            value={newChannelData.AccountGroupName || ""}
            onChange={(e) => handleNewInputChange(e, "AccountGroupName")}
            onBlur={() =>
              setAccountGroupNameValid(!!newChannelData.AccountGroupName)
            }
            className={!accountGroupNameValid ? "p-invalid" : ""}
          />
        </div>
        <div className="p-field">
          <label htmlFor="AccountGroupCode">AccountGroupCode</label>
          <InputText
            id="AccountGroupCode"
            value={newChannelData.AccountGroupCode || ""}
            onChange={(e) => handleNewInputChange(e, "AccountGroupCode")}
            onBlur={() =>
              setAccountGroupCodeValid(!!newChannelData.AccountGroupCode)
            }
            className={!accountGroupCodeValid ? "p-invalid" : ""}
          />
        </div>
      </div>
    </>
  );
  const handleConfirmDelete = async () => {
    try {
      const requestBody = {
        AccountgroupId: selectedChennal.AccountgroupId,
      };
      const response = await DeleteAPICall(
        "api/AccountGroup/DeleteAccountGroupHeader",
        requestBody
      );
      fetchAccountGroupType();
      setDeleteConfirmation(false);
      showSuccessToast("Deleted...");
    } catch (error) {
      console.error(error);
    }
  };
  const rowClassName = (rowData) => {
    if (selectedRows && selectedRows.length > 0) {
      const isSelected = selectedRows.some(
        (row) => row.AccountGroupCode === rowData.AccountGroupCode
      );
      return isSelected ? "selected-row" : "";
    }
    return "";
  };
  const EditChannelFooter = (
    <>
      <div>
        <Button
          style={{ borderRadius: "5px", padding: "15px" }}
          label="Submit"
          icon="pi pi-check"
          onClick={handleSubmitEdit}
          autoFocus
        />
        <Button
          style={{
            borderRadius: "5px",
            padding: "15px",
            backgroundColor: "lightslategray",
            color: "white",
          }}
          label="Cancel"
          icon="pi pi-times"
          onClick={() => setEditDialogVisible(false)}
          className="p-button-text"
        />
      </div>
    </>
  );
  const editChannelContent = (
    <>
      <div className="p-fluid" style={{ padding: "10px" }}>
        <div className="p-field">
          <label htmlFor="AccountGroupName">AccountGroupName</label>
          <InputText
            id="AccountGroupName"
            name="AccountGroupName"
            value={editedAccountGroup?.AccountGroupName}
            onChange={handleInputChange}
            onBlur={() =>
              setAccountGroupNameValid(!!editedAccountGroup?.AccountGroupName)
            }
            className={!accountGroupNameValid ? "p-invalid" : ""}
          />
        </div>
        <div className="p-field">
          <label htmlFor="AccountGroupCode">AccountGroupCode</label>
          <InputText
            id="AccountGroupCode"
            name="AccountGroupCode"
            value={editedAccountGroup?.AccountGroupCode}
            onChange={handleInputChange}
            onBlur={() =>
              setAccountGroupCodeValid(!!editedAccountGroup?.AccountGroupCode)
            }
            className={!accountGroupCodeValid ? "p-invalid" : ""}
          />
        </div>
        <div
          className="p-field"
          hidden={props?.hideMultiSelect == "True" ? false : true}
        >
          <label htmlFor="days">Number of Days</label>
          <InputNumber
            id="days"
            value={editedAccountGroup?.Days}
            onValueChange={(e) => setDays(e.value)}
            min={0}
            placeholder="Enter number of days"
            mode="decimal"
            className="p-inputnumber p-component"
          />
        </div>
      </div>
    </>
  );
  const DeleteConfirmation = (
    <>
      <div>
        <Button
          style={{ borderRadius: "5px", padding: "15px" }}
          label="Yes"
          icon="pi pi-check"
          onClick={handleConfirmDelete}
          autoFocus
        />
        <Button
          style={{
            borderRadius: "5px",
            padding: "15px",
            backgroundColor: "lightslategray",
            color: "white",
          }}
          label="No"
          icon="pi pi-times"
          onClick={() => setDeleteConfirmation(false)}
          className="p-button-text"
        />
      </div>
    </>
  );
  return (
    <div>
      <Toast ref={toast} />
      <div
        id="plus_search"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <b
          style={{
            color: "lightslategray",
            marginRight: "auto",
            marginTop: "10px",
          }}
        >
          {props.newUserName}
        </b>
        <Button
          visible={props?.hideMultiSelect == "True" ? false : true}
          icon={
            <IoAddOutline
              style={{ color: "darkslategrey", fontSize: "50px" }}
            />
          }
          id="MasterPlusicon"
          onClick={() => setShowDialog(true)}
          className="p-button p-button-icon"
          title="Add"
        />
        <InputText
          id="AccountGroupSearch"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          className="p-button-primary"
          title="Search"
        />
      </div>
      <DataTable
        header={props?.hideMultiSelect == "True" ? "Channel" : ""}
        value={filteredAccountGroupType}
        className="p-datatableAccountGroup"
        scrollable
        scrollHeight="440px"
        selection={selectedItem ? selectedItem : selectedRows}
        onSelectionChange={onRowSelected}
        onRowUnselect={Chkboxunselect}
        onRowSelect={Chkboxselect}
        onAllRowsSelect={HandleAllrowselect}
        onAllRowsUnselect={HandleAllRowUnSelect}
        rowClassName={rowClassName}
      >
        <Column
          selectionMode={
            props?.hideMultiSelect == "True" ? "single" : "multiple"
          }
          style={{ width: "3em" }}
        />
        <Column
          field="AccountGroupCode"
          header="AccountGroupCode"
          style={{ width: "20%" }}
          hidden
        />
        <Column field="AccountGroupName" header="AccountGroupName" sortable />
        <Column field="UserId" header="UserId" sortable hidden />
        <Column header="Actions" body={actionTemplate} />
      </DataTable>
      <GlobalPopup
        title="Edit Channels"
        visible={editDialogVisible}
        onHide={() => setEditDialogVisible(false)}
        footerButtons={EditChannelFooter}
        content={editChannelContent}
      />
      <GlobalPopup
        title="Add New Channel"
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        footerButtons={AddNewChannelFooter}
        content={AddChannelContent}
      />
      <GlobalPopup
        title={"Confirmation"}
        visible={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
        footerButtons={DeleteConfirmation}
        content={
          <div className="confirmation-content">
            Are you sure you want to delete this item?
          </div>
        }
      />
    </div>
  );
}
